import { Helmet } from 'react-helmet-async';

interface ArticleSchemaProps {
  title: string;
  description: string;
  url: string;
  image?: string;
  authorName: string;
  datePublished: string;
  dateModified?: string;
}

const ArticleSchema = ({
  title,
  description,
  url,
  image,
  authorName,
  datePublished,
  dateModified,
}: ArticleSchemaProps) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    description,
    mainEntityOfPage: url,
    image: image ? [image] : undefined,
    author: {
      '@type': 'Person',
      name: authorName,
    },
    publisher: {
      '@type': 'Organization',
      name: 'SeniorThrive',
      logo: {
        '@type': 'ImageObject',
        url: 'https://seniorthrive.com/favicon.ico',
      },
    },
    datePublished,
    dateModified: dateModified || datePublished,
  } as const;

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default ArticleSchema;
